import { css } from "@emotion/css"

type Props = {
  children: React.ReactNode
}

const MyPageButtonContainer = ({ children }: Props) => {
  return <div className={styles.buttonContainer}>{children}</div>
}

export default MyPageButtonContainer

const styles = {
  buttonContainer: css`
    display: flex;
    column-gap: 20px;
    justify-content: center;
  `,
}
